import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { CardActionArea, CardMedia } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    minWidth: 275,
    margin: 5,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
  media: {
    height: 140,
  },
});

export default function SimpleCard(props: any) {
  const {background_color, cta_action, cta_title, cta_type, description, image_path, title} = props;
  const classes = useStyles();

  return (
    <Card className={classes.root} style={{backgroundColor: background_color}}>
      <CardActionArea>
        <CardMedia
            className={classes.media}
            image={image_path}
            title="Contemplative Reptile"
          />
      </CardActionArea>
        <CardContent>
            <Typography className={classes.title} color="textSecondary" gutterBottom>
            {title}
            </Typography>
            <Typography variant="body2" component="p">
            {description}
            </Typography>
        </CardContent>
        <CardActions>
            <Button size="small">{cta_title}</Button>
        </CardActions>
    </Card>
  );
}